angular.module 'zc.projects'

.service 'mainChartItems', ($filter) ->
  [
    name: 'session_count'
    label: $filter('translate')('projectsAnalytics.mainChartItems.sessionCount')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.visit')
      valueDecimals: 0
  ,
    name: 'conversion_count'
    label: $filter('translate')('projectsAnalytics.mainChartItems.conversionCount')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.visit')
      valueDecimals: 0
  ,
    name: 'conversion_rate'
    label: $filter('translate')('projectsAnalytics.mainChartItems.conversionRate')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' %'
      valueDecimals: 2
  ,
    name: 'conversion_price'
    label: $filter('translate')('projectsAnalytics.mainChartItems.conversionPrice')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' 円'
      valueDecimals: 0
  ,
    name: 'cart_button_click_rate'
    label: $filter('translate')('projectsAnalytics.mainChartItems.cartButtonClickRate')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' %'
      valueDecimals: 2
  ,
    name: 'average_conversion_price'
    label: $filter('translate')('projectsAnalytics.mainChartItems.averageConversionPrice')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' 円'
      valueDecimals: 0
  ,
    name: 'average_dwell'
    label: $filter('translate')('projectsAnalytics.mainChartItems.averageDwell')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.minute')
      valueDecimals: 2
  ,
    name: 'average_history_count'
    label: $filter('translate')('projectsAnalytics.mainChartItems.averageHistoryCount')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.pageView')
      valueDecimals: 2
  ,
    name: 'history_count'
    label: $filter('translate')('projectsAnalytics.mainChartItems.historyCount')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.pageView')
      valueDecimals: 0
  ,
    name: 'average_interest_count'
    label: $filter('translate')('projectsAnalytics.mainChartItems.averageInterestCount')
    tooltip:
      valuePrefix: ''
      valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.pageView')
      valueDecimals: 2
  ]



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.analytics/main_chart_items.coffee